import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BottomNav from "@/components/BottomNav";
import HomePage from "@/pages/HomePage";
import IdentifyPage from "@/pages/IdentifyPage";
import AskPage from "@/pages/AskPage";
import YardPlanPage from "@/pages/YardPlanPage";
import SavedPlantsPage from "@/pages/SavedPlantsPage";
import ShoppingListPage from "@/pages/ShoppingListPage";
import PlantDetailPage from "@/pages/PlantDetailPage";

function getDeviceId() {
  let id = localStorage.getItem("garden_guide_device_id");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("garden_guide_device_id", id);
  }
  return id;
}

function AppContent() {
  const [deviceId] = useState(getDeviceId);
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background max-w-2xl mx-auto relative" data-testid="app-container">
      <main className="pb-24">
        <Routes>
          <Route path="/" element={<HomePage deviceId={deviceId} />} />
          <Route path="/identify" element={<IdentifyPage deviceId={deviceId} />} />
          <Route path="/ask" element={<AskPage deviceId={deviceId} />} />
          <Route path="/yard-plan" element={<YardPlanPage deviceId={deviceId} />} />
          <Route path="/my-plants" element={<SavedPlantsPage deviceId={deviceId} />} />
          <Route path="/shopping-list" element={<ShoppingListPage deviceId={deviceId} />} />
          <Route path="/plant/:plantId" element={<PlantDetailPage deviceId={deviceId} />} />
        </Routes>
      </main>
      <BottomNav currentPath={location.pathname} />
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
